import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SessionService} from "../../session/session.service";
import {NavigationEnd, Router, RoutesRecognized} from "@angular/router";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {SearchService} from "../../services/search.service";
import {Observable, Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {MatDrawer} from "@angular/material/sidenav";
import {Usuario} from "../../model/personas/usuario.model";
import {Persona} from "../../model/personas/persona.model";
import * as moment from "moment";
import {ConversacionesService} from "../../pages/mensajes/conversaciones.service";
import {puedeUsarMensajes} from "../../pages/mensajes/acceso-mensajes";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    title = '';
    public searchGroup: UntypedFormGroup;
    public displayClock = false;
    public clock = null;
    public profileClock = '';
    public readonly pendientes$: Observable<number>;

    @Input() public drawer: MatDrawer;
    @Input() public isHandset$: Observable<boolean>;
    @Input() public menuAvailable: boolean;
    @Input() public mostrarToolBar: boolean;

    public get profileName(): string {
        const profile = this.sessionService.profile;
        if (profile instanceof Usuario) {
            return profile.username;
        } else if (profile instanceof Persona) {
            return profile.nombreCompleto;
        }
        return '';
    }

    public get sessionMinutesLeft(): number {
        return this.sessionService.isLogged() ?
            this.sessionService.token.expiration.diff(moment(), 'm') :
            Infinity;
    }

    private _clockInterval;
    private _sesion: Subscription | null = null;

    constructor(fb: UntypedFormBuilder,
                public searchService: SearchService,
                public sessionService: SessionService,
                private _router: Router,
                private _conversaciones: ConversacionesService) {
        this.pendientes$ = this._conversaciones.resumen$.pipe(map(r => r.pendientesRespuesta ?? 0));
        this._router.events.subscribe(data => {
            if (data instanceof RoutesRecognized) {
                let title = data.state.root.firstChild.data['title'];
                this.displayClock = !!data.state.root.firstChild.data['displayClock'];
                if (title) {
                    this.title = title;
                } else {
                    title = data.state.root.children[0].children[0]?.data['title'];
                    if (title) {
                        this.title = title;
                    } else {
                        this.title = '';
                    }
                }
            }
            // Solo con mensajes (empleado o comercial con ROLE_MENSAJES): a cualquier otro la API le niega el resumen (403).
            if (data instanceof NavigationEnd && this.mensajes) {
                this._conversaciones.refrescarResumen();
            }
        });

        this.searchGroup = fb.group({search: ''});
        searchService.search.subscribe(s => this.searchGroup.controls['search'].setValue(s, {emitEvent: false}));
        this.searchGroup.controls['search'].valueChanges
            .subscribe(v => searchService.currentSearch = v);
    }

    public logout() {
        this.sessionService.logout();
        this._router.navigateByUrl('/');
        window.location.reload();

    }

    ngOnInit() {
        // El login navega sin recargar la página: además de al arrancar, se mira en cada cambio de
        // sesión (entrar, salir o caducar el token).
        this._seguirSesionEnMensajes();
        this._sesion = this.sessionService.sessionChanges.subscribe(() => this._seguirSesionEnMensajes());
        /* this._clockInterval = setInterval(() => {
             this.clock = moment().format('HH:mm');
             if (this.sessionService.isLogged()) {
                 const diff = this.sessionService.token.expiration.diff(moment(), 's');
                 const duration = moment.duration(diff, 's');
                 let format = 'mm[\'] ss["]';
                 if (duration.asHours() > 1) {
                     format = 'HH[h] mm[\']';
                 }
                 this.profileClock = '- expira en: ' + moment.utc(+duration).format(format);
             } else {
                 this.profileClock = '';
             }
         }, 500);*/
    }

    ngOnDestroy(): void {
        clearInterval(this._clockInterval);
        this._sesion?.unsubscribe();
        this._conversaciones.detenerSondeo();
    }

    /** Si la sesión tiene mensajes (ver acceso-mensajes.ts). */
    public get mensajes(): boolean {
        return puedeUsarMensajes(this.sessionService);
    }

    /** Sondeo y avisos solo con mensajes. iniciarSondeo() no duplica el temporizador. */
    private _seguirSesionEnMensajes(): void {
        if (!this.mensajes) {
            this._conversaciones.detenerSondeo();
            return;
        }
        this._conversaciones.iniciarSondeo();
        // Qué avisos oye lo dice la API, igual que su token de Mercure: el admin, cnc; un empleado, sus
        // grupos; un comercial, el suyo.
        this._conversaciones.grupos().subscribe({
            next: r => this._conversaciones.conectarAvisos(r.avisos ?? [], this.sessionService.mercureToken),
            error: () => null
        });
    }
}
